import React, { useState} from 'react'
import { Modal, Alert, Row, Col, Form, Button } from 'react-bootstrap'
import { usersService } from '../../../../../../_services/users.service'

export default function SettingsModal({
  user,
  show,
  handleClose
}) {

  const [error, setError] = useState('')
  const [notificationSettings, setNotificationSettings] = useState(user.messageNotifications)


  const handleToggleNotifications = () => {
    setError('')

    const originalValue = notificationSettings
    setNotificationSettings(!notificationSettings)

    usersService.toggleNotifications(user.licensedId, !originalValue)
      .then(status => {
        setNotificationSettings(status)
      })
      .catch(() => {
        setError('Could not update notification settings at this time. Please try again.')
        setNotificationSettings(originalValue)
      })
  }

  return (
    <Modal size='lg' show={show} onHide={handleClose} style={{height: '387px'}}>
      <Modal.Header closeButton>
        <Modal.Title>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { error && <Alert variant='danger'>{error}</Alert> }
        <Row>
          <Col>
            <p>Message Notifications</p>
            <p className='font-weight-light text-muted'>By default, only the team will receive message notifications unless Notify Licensed User is enabled.</p>
          </Col>
          <Col>
          <Form.Check 
            id="custom-switch"
            type="switch"
            label="Notify Licensed User"
            checked={notificationSettings}
            onChange={handleToggleNotifications}
          />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} variant="secondary" className='px-4' >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
